// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:34:45

export default {
  "id": "the-last-tiger-tank-simulator",
  "slug": "the-last-tiger-tank-simulator",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/909354f462854f099c83daf02ae9a017-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/909354f462854f099c83daf02ae9a017/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "The Last Tiger: Tank Simulator",
      "description": "An incredible adventure in the world of tank battles awaits you!\nGet ready to immerse yourself in the exciting world of tank battles. In this game, you will take control of one of the most famous tanks of World War II, the Tiger. Your task is to survive and win the fiercest battles.",
      "instructions": "W / A / S / D - movement\nMouse - camera\nLMB - shoot\nRMB - aim\nMouse wheel - adjust scope range\n\nSpace - assist aiming\nECS - pause\nV - change ammo type\nF - change camera",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "3d",
        "arcade",
        "shoot-em-up",
        "tank",
        "war"
      ]
    },
    "zh-CN": {
      "title": "最后的虎：坦克模拟器",
      "description": "一场惊心动魄的坦克战世界冒险等待着您！\n准备好沉浸于激动人心的坦克战世界。在这款游戏中，您将操控二战中最著名的坦克之一——虎式坦克。您的任务是生存并赢得最激烈的战斗。",
      "instructions": "W / A / S / D - 移动\n鼠标 - 控制摄像头\n左鼠标键 - 射击\n右鼠标键 - 瞄准\n鼠标滚轮 - 调整瞄准范围\n\n空格键 - 辅助瞄准\nECS - 暂停\nV - 切换弹药类型\nF - 切换摄像头",
      "genres": [
        "模拟"
      ],
      "tags": [
        "三维",
        "街机",
        "射击游戏",
        "坦克",
        "战争"
      ]
    },
    "zh-TW": {
      "title": "最後的獅子：坦克模擬器",
      "description": "一場難以置信的坦克戰爭冒險等著你！\n準備好沉浸於刺激的坦克戰爭世界。在這款遊戲中，你將操控二戰中最著名的坦克之一，虎式坦克。你的任務是存活並贏得最激烈的戰鬥。",
      "instructions": "W / A / S / D - 移動\n滑鼠 - 相機\n左鍵 - 射擊\n右鍵 - 瞄準\n滑鼠滾輪 - 調整倍數範圍\n\n空格鍵 - 試圖瞄准\nECS - 暫停\nV - 切換彈藥類型\nF - 切換相機",
      "genres": [
        "模擬"
      ],
      "tags": [
        "3D",
        "街機",
        "射擊遊戲",
        "戰車",
        "戰爭"
      ]
    },
    "zh-HK": {
      "title": "最後的虎：坦克模擬器",
      "description": "一場令人驚嘆的坦克戰爭冒險等著你！\n準備好沉浸於熱血沸騰的坦克戰爭世界。在這款遊戲中，你將操縱二戰中最著名之一的坦克——虎式坦克。你的任務是生存並贏得最激烈的戰鬥。",
      "instructions": "W / A / S / D - 補位移動\n滑鼠 - 鏡頭操控\n左鍵 - 射擊\n右鍵 - 定位\n滑鼠滾輪 - 調整槍口範圍\n\n空格鍵 - 協助定位\nECS - 暂停\nV - 更換彈藥類型\nF - 更換鏡頭",
      "genres": [
        "模擬"
      ],
      "tags": [
        "3D",
        "街機",
        "射擊遊戲",
        "戰車",
        "戰爭"
      ]
    },
    "ja": {
      "title": "最後のトラガー：戦車シミュレーター",
      "description": "戦車戦の世界における驚異的な冒険があなたを待っています！\n戦車戦の興奮的な世界に没頭する準備をしよう。このゲームでは、第二次世界大戦で最も有名な戦車の一つ、ティーガーを操縦することになります。あなたのタスクは生き延びて最も激しい戦闘に勝つことです。",
      "instructions": "W / A / S / D - 移動\nマウス - カメラ\nLMB - ショット\nRMB - 瞄準\nマウスホイール - スコープ範囲調整\n\nスペース - 瞄準補助\nECS - ポーズ\nV - 弾薬種類変更\nF - カメラ変更",
      "genres": [
        "シミュレーション"
      ],
      "tags": [
        "3D",
        "アーケード",
        "シューティングゲーム",
        "戦車",
        "戦争"
      ]
    },
    "ko": {
      "title": "지지 않는 타이거: 탱크 시뮬레이터",
      "description": "坦克전쟁의 세계에서의 장대한 모험을 기다리고 있습니다!\n톱니바퀴 전쟁의 흥미진진한 세계에 몰입해 보세요. 이 게임에서는 제2차 세계대전에서 가장 유명한 탱크 중 하나인 타이거를 조종하게 됩니다. 여러분의 임무는 생존하고 가장 치열한 전투를 승리로 이끌는 것입니다.",
      "instructions": "W / A / S / D - 이동\n마우스 - 카메라\n좌鼠标 - 발사\n우鼠标 - 정확도 조정\n마우스 휠 - 시야 범위 조정\n\n공간 - 정확도 지원\nECS - 일시 중지\nV - 탄약 유형 변경\nF - 카메라 변경",
      "genres": [
        "시뮬레이션"
      ],
      "tags": [
        "3D",
        "아케이드",
        "쏘션 업",
        "탱크",
        "전쟁"
      ]
    },
    "fr": {
      "title": "Le Dernier Tigre : Simulateur de Chasseur de chars",
      "description": "Une aventure incroyable dans le monde des batailles de chars vous attend !\nPréparez-vous à vous immerger dans le monde passionnant des batailles de chars. Dans ce jeu, vous prendrez le contrôle d'un des chars les plus célèbres de la Seconde Guerre mondiale, le Tiger. Votre tâche est de survivre et de gagner les batailles les plus féroces.",
      "instructions": "W / A / S / D - déplacement\nSouris - caméra\nClic gauche - tirer\nClic droit - viser\nRoue de la souris - ajuster la portée du viseur\n\nEspace - aider au viseignement\nECS - mettre en pause\nV - changer le type de munitions\nF - changer de caméra",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "3D",
        "flipper",
        "shoot-em-up",
        "chariot",
        "guerre"
      ]
    }
  }
};
